import { FormFeedback, FormGroup, Input, Label } from "reactstrap";
import React from "react";

export const FloatingInput = ({label, feedback, invalid, ...props}) => {
    return <FormGroup floating>
        <Input type="text" invalid={invalid}{...props}/>
        <Label>{label}</Label>
        <FormFeedback valid={!invalid}>{feedback}</FormFeedback>
    </FormGroup>
}